/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FollowSearchButton_favoritesConnection$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespFollowSearchTopButton_user$ref: FragmentReference;
export type SbRespFollowSearchTopButton_user = {|
  +serviceId: ?string,
  +favorites: ?{|
    +$fragmentRefs: FollowSearchButton_favoritesConnection$ref
  |},
  +$refType: SbRespFollowSearchTopButton_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespFollowSearchTopButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchTypes",
      "type": "[types]"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "favorites",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "pages",
          "variableName": "followSearchPages",
          "type": "[String]"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "followSearchTypes",
          "type": "[types]"
        }
      ],
      "concreteType": "favoritesConnection",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FollowSearchButton_favoritesConnection",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a3c6a58e43da1f5d7cdfe1744df9c8d1';
module.exports = node;
